/*
 * Liefertermin auf Produktkarten ("Lieferung Do, 08.10. – Fr, 09.10.", ohne " · nach 84028"; ohne PLZ kurz
 * "Lieferung 8.–9. Okt.", damit es in eine Zeile passt).
 *
 * Markup: snippets/altruan-card-lieferung.liquid (Einteilung Lager/Lieferzeit-Ware wie im
 * Liefer-Widget). Text (label der Shipping-App) und Zwischenspeicher kommen aus
 * assets/altruan-lieferdatum.js, das auch der Preisblock der Produktseite nutzt. Die App rechnet nur
 * nach Land + Bestand + Lieferort, daher gehen pro Seite höchstens zwei Anfragen raus, egal wie viele
 * Karten es gibt. Ein neuer Lieferort (Event "altruan-lieferort:change") füllt alle Karten neu.
 *
 * Warenkorb: dieselbe Zeile steht an jeder Position (snippets/cart-position.liquid). Zusätzlich nennt
 * die Summenbox (snippets/cart-summe.liquid, [data-cart-lieferung]) einen Termin für die ganze
 * Bestellung: spätester erster – spätester letzter Liefertag aller Positionen und die Position, die ihn
 * bestimmt ("Lieferung Di, 10.11. – Mi, 11.11. · bestimmt durch …"). Teillieferungen werden nicht
 * versprochen. Die Tage stammen aus den labels der Positionen und sehen deshalb genau so aus.
 */
(() => {
  if (window.altruanCardLieferung) return;
  window.altruanCardLieferung = true;

  const SELECTOR = "[data-card-lieferung]:not([data-card-lieferung-done])";
  const shopify = window.Shopify || {};

  // Der Lieferort steht schon im Kopf; im Kartenraster würde "· nach 84028" auf jeder Karte stehen.
  // Abgeschnitten wird nur der letzte "· …"-Teil und nur, wenn er die gewählte PLZ enthält.
  const withoutPlace = (text) => {
    const where = window.AltruanLieferort && window.AltruanLieferort.get();
    const zip = where && where.postal_code;
    const cut = text.lastIndexOf(" · ");
    return zip && cut > 0 && text.slice(cut).includes(zip) ? text.slice(0, cut) : text;
  };

  // Ohne PLZ nennt die App einen Zeitraum mit Wochentagen ("Lieferung Do, 29.10. – Fr, 30.10."), der in
  // der Karte (~156 px) umbricht. Im Produktraster dann kurz wie vor der App: "Lieferung 29.–30. Okt.".
  // Das volle label bleibt in data-label für die Summenbox im Warenkorb.
  const toDate = (iso) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
    return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
  };
  const shortText = (info) => {
    const where = window.AltruanLieferort && window.AltruanLieferort.get();
    if (where && where.postal_code) return null;
    const from = toDate(info.minDate);
    const to = toDate(info.maxDate);
    if (!from || !to) return null;
    try {
      const fmt = new Intl.DateTimeFormat(shopify.locale || document.documentElement.lang || "de", {
        day: "numeric",
        month: "short",
      });
      let range = fmt.format(to);
      if (from.getTime() !== to.getTime())
        range = fmt.formatRange ? fmt.formatRange(from, to) : `${fmt.format(from)} – ${range}`;
      const prefix = splitLabel(info.label).prefix;
      return prefix ? prefix + range : null;
    } catch (_) {
      return null;
    }
  };

  // Nur bei neuem Text schreiben: sonst meldet der MutationObserver unten jede Aktualisierung erneut
  const setText = (el, text) => {
    if (el && el.textContent !== text) el.textContent = text;
  };

  // ---------- Termin der ganzen Bestellung (Summenbox im Warenkorb) ----------
  // "Lieferung Di, 10.11. – Mi, 11.11." → Präfix "Lieferung ", Tage ["Di, 10.11.", "Mi, 11.11."]
  const DAY = /[^\s,]+, \d{2}\.\d{2}\./g;
  const splitLabel = (label) => {
    const days = label.match(DAY) || [];
    return { prefix: days.length ? label.slice(0, label.indexOf(days[0])) : "", days };
  };

  const renderOrderDate = (box) => {
    // Seitenwarenkorb und Warenkorbseite getrennt: nur Positionen derselben Ansicht
    const drawer = box.closest("cart-drawer");
    const lines = Array.from((drawer || document).querySelectorAll(".cart-pos [data-card-lieferung][data-max]")).filter(
      (el) => !el.hidden && (drawer || !el.closest("cart-drawer")),
    );
    if (!lines.length) {
      box.hidden = true;
      return;
    }

    // Bestimmend: spätester letzter Liefertag, bei Gleichstand spätester erster, sonst Reihenfolge
    const last = lines.reduce((a, b) =>
      b.dataset.max > a.dataset.max || (b.dataset.max === a.dataset.max && b.dataset.min > a.dataset.min) ? b : a,
    );
    const first = lines.reduce((a, b) => (b.dataset.min > a.dataset.min ? b : a));
    const lastLabel = splitLabel(last.dataset.label || "");
    const maxDay = lastLabel.days[lastLabel.days.length - 1];
    const minDay = splitLabel(first.dataset.label || "").days[0];

    let text = last.dataset.label || "";
    if (maxDay && minDay) {
      text =
        first.dataset.min === last.dataset.max ? lastLabel.prefix + maxDay : `${lastLabel.prefix}${minDay} – ${maxDay}`;
    }
    setText(box.querySelector("[data-cart-lieferung-date]"), text);

    const by = box.querySelector("[data-cart-lieferung-by]");
    const title = last.dataset.cardLieferungTitle || "";
    if (by) {
      by.hidden = !(lines.length > 1 && title);
      setText(by, by.hidden ? "" : (box.dataset.byTemplate || "").replace("__TITLE__", title));
    }
    box.classList.toggle("is-backorder", last.dataset.cardLieferung === "backorder");
    box.hidden = false;
  };

  let orderDateQueued = false;
  const updateOrderDates = () => {
    if (orderDateQueued) return;
    orderDateQueued = true;
    requestAnimationFrame(() => {
      orderDateQueued = false;
      document.querySelectorAll("[data-cart-lieferung]").forEach(renderOrderDate);
    });
  };

  const fill = (root = document) => {
    if (!window.AltruanLieferdatum) return;
    const els = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    els.forEach((el) => {
      el.setAttribute("data-card-lieferung-done", "");
      window.AltruanLieferdatum.info({
        country: shopify.country || "DE",
        inStock: el.dataset.cardLieferung === "stock",
        locale: shopify.locale,
      }).then((info) => {
        const target = el.querySelector("[data-card-lieferung-date]");
        if (!target) return;
        if (!info) {
          el.hidden = true;
          delete el.dataset.max;
        } else {
          const text = withoutPlace(info.label);
          setText(target, el.closest(".cart-pos") ? text : shortText(info) || text);
          // Für den Termin der ganzen Bestellung (Summenbox)
          el.dataset.label = text;
          if (info.minDate && info.maxDate) {
            el.dataset.min = info.minDate;
            el.dataset.max = info.maxDate;
          }
          el.hidden = false;
        }
        updateOrderDates();
      });
    });
  };

  const start = () => {
    fill();
    updateOrderDates();
    // Filter, Sortierung, "Mehr laden" und Quick-View ersetzen das Produktgrid per AJAX; der Warenkorb
    // (cart.js, cart-drawer.js) ersetzt Positionen und Summenbox nach jeder Änderung.
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) fill(node.matches(SELECTOR) ? node.parentNode : node);
        }
      }
      if (document.querySelector("[data-cart-lieferung]")) updateOrderDates();
    }).observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener("altruan-lieferort:change", () => {
    document
      .querySelectorAll("[data-card-lieferung-done]")
      .forEach((el) => el.removeAttribute("data-card-lieferung-done"));
    fill();
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
